import { render } from "./InProgressDealsCard.vue?vue&type=template&id=5d3966fa&scoped=true"
import script from "./InProgressDealsCard.vue?vue&type=script&lang=js"
export * from "./InProgressDealsCard.vue?vue&type=script&lang=js"

import "./InProgressDealsCard.vue?vue&type=style&index=0&id=5d3966fa&lang=scss&scoped=true"
import "./InProgressDealsCard.vue?vue&type=style&index=1&id=5d3966fa&lang=scss"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3966fa"]])

export default __exports__